import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from '..';
import { DotsVerticalIcon } from '../../icons';
export function OptionsDropdown({ options, icon: Icon = DotsVerticalIcon }) {
    return (_jsx(Dropdown, { options: options, children: _jsx("button", { className: "p-stack-tight border border-transparent hover:border-border hover:bg-surface rounded-surface transition-colors", children: _jsx(Icon, { className: "size-4 text-fg-muted" }) }) }));
}
